<div class="cm-page">
  <ng-container *ngIf="!isBlocked; else blockedTemplate">
    <app-cm-sidenav class="cm-rail" [class.open]="layout.railOpen$ | async"></app-cm-sidenav>
    <div class="cm-scrim" *ngIf="layout.railOpen$ | async" (click)="closeRail()"></div>
    <div class="cm-main">
      <router-outlet></router-outlet>
    </div>
  </ng-container>
  <ng-template #blockedTemplate>
    <div class="cm-blocked">
      <p>{{ isLoading ? 'Connecting to community...' : 'You have been blocked' }}</p>
      <button *ngIf="!isLoading" class="cm-btn cm-btn--primary" (click)="goToHome()">Go to Home</button>
    </div>
  </ng-template>
</div>
